import { ReactComponent as AiIcon } from 'assets/icons/ai.svg';

import type IAIGeneratingModalHeader from './interfaces/IAIGeneratingModalHeader';

import styles from './sass/AIGeneratingModalHeader.module.scss';

function AIGeneratingModalHeader({
  title,
  description,
  afterTitle,
}: IAIGeneratingModalHeader) {
  return (
    <div className={styles.header}>
      <div className={styles.iconWrapper} aria-hidden="true">
        <span className={styles.rotatingArc} />
        <div className={styles.iconInner}>
          <AiIcon className={styles.icon} />
        </div>
      </div>
      <div className={styles.textContent}>
        <h2 className={styles.title}>{title}</h2>
        {afterTitle ? (
          <div className={styles.afterTitle}>{afterTitle}</div>
        ) : null}
        {description ? (
          <p className={styles.description}>{description}</p>
        ) : null}
      </div>
    </div>
  );
}

export default AIGeneratingModalHeader;
